// import readCookie from './readCookie';

var getGeoLocation = (function () {

    var setUpGeoLocation = function () {
        function readCookie(name){
            var nameEQ = name + "=";
            var cookieArr = document.cookie.split(';');
            for(var i=0;i < cookieArr.length;i++) {
                var itemVal = cookieArr[i];
                while (itemVal.charAt(0)==' ') itemVal = itemVal.substring(1,itemVal.length);
                if (itemVal.indexOf(nameEQ) == 0) return itemVal.substring(nameEQ.length,itemVal.length);
            }
            return null;
        }
          // Geo Trigger.
          $('.c-button--trigger-geo-navigator1').click(function(){
            if(readCookie('latitude')){
                window.location.href='/return-points';
            }
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    successHandling,
                    errorHandling
                )
            }
          });
          $('.c-button--trigger-geo-navigator2').click(function(){
            if(readCookie('latitude')){
                window.location.href='/return-points';
            }
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    successHandling,
                    errorHandling
                )
            }
          });
          $('.c-button--trigger-geo-navigator3').click(function(){
            if(readCookie('latitude')){
                window.location.href='/return-points';
            }
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    successHandling,
                    errorHandling
                )
            }
          });
        // function setCookie (name,value,expires,path,theDomain,secure) { 
        //     value = escape(value);
        //     var theCookie = name + "=" + value + 
        //     ((expires)    ? "; expires=" + expires.toGMTString() : "") + 
        //     ((path)       ? "; path="    + path   : "") + 
        //     ((theDomain)  ? "; domain="  + theDomain : "") + 
        //     ((secure)     ? "; secure"            : ""); 
        //     document.cookie = theCookie;
        // } 
        function successHandling(position){
            let now = new Date();
            let time = now.getTime();
            let expireTime = time + 1000*3600000;
            now.setTime(expireTime);
            let expires = '; expires=' + now.toUTCString();
            // let expires = now;
            if(position){
                document.cookie = "latitude=" + position.coords.latitude + expires + '; path=/';
                document.cookie = "longitude=" + position.coords.longitude + expires + '; path=/';
                document.cookie = "locationName=" + 'nearby' + expires + '; path=/';
                // setCookie("latitude",position.coords.latitude,expires,"/");
                // setCookie("longitude",position.coords.longitude,expires,"/");
                // setCookie("locationName","nearby",expires,"/");
                if(readCookie('latitude')){
                    window.location.href='/return-points';
                }
            }
            // window.location.href='/return-point-results.html';
        }
        function errorHandling(error){
            window.location.href='/return-points';
        }
  }
  
    var init = function () {
        setUpGeoLocation();
    };
  
    return {
      init: init
    };
})();
  
export default getGeoLocation;


// WEBPACK FOOTER //
// ./FE-Build/src/js/modules/geoLocation.js